
import store from '../store'

export default {
	watch: {
        loggedUser : function (newValue, oldValue) {
        }
    },
    computed: {
        loggedUser() {
            return store.getters['user/user'];
        },
        loggedUserIsSuperAdmin() {
            return this.loggedUser.roles.includes('ROLE_SUPER_ADMIN');
        },
        loggedUserIsAdmin() {
            return this.loggedUser.roles.includes('ROLE_ADMIN');
        },
    },
    methods : {
        getURL(path = null){
            if (path == null) return  process.env.MIX_BASE_URL ;
            
            if (path.charAt(0) == '/' ) return process.env.MIX_BASE_URL + path.substr(1);

            return process.env.MIX_BASE_URL + path;

        },
        getBaseUrl(){
        	return  process.env.MIX_BASE_PATH ;
        },
        getApiUrl(){
            return  process.env.VUE_APP_API_URL ;
        },
        asset( link = '' , base = false){
            return  this.getBaseUrl() + (base ? '/../' : '') +   link ;
        },
    }
}
